/* eslint-disable react/require-default-props */
import React, { useCallback, useEffect, useState } from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

import { StyledButton, StyledInputWithIcon } from '../../../../components';
import { StatusModal } from '../../../../components/StatusModal';
import { Button, ButtonsContainer, Container, Form } from './styles';
import { api } from '../../../../services/api';

interface IProps {
  userEmail: string;
  setHandleChangePass: (value: boolean) => void;
  setFormView: (value: boolean) => void;
  setLoading: (value: boolean) => void;
}

const PasswordForm = ({
  userEmail,
  setHandleChangePass,
  setFormView,
  setLoading,
}: IProps) => {
  const [formReady, setFormReady] = useState(false);

  const [modal, setModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalType, setModalType] = useState<'success' | 'error'>('success');

  const [currentPass, setCurrentPass] = useState('');
  const [currentPassError, setCurrentPassError] = useState('');

  const [newPass, setNewPass] = useState('');
  const [newPassError, setNewPassError] = useState('');

  const [confirmNewPass, setConfirmNewPass] = useState('');
  const [confirmNewPassError, setConfirmNewPassError] = useState('');

  const [showIconCurrentPass, setShowIconCurrentPass] = useState(false);
  const [showIconNewPass, setShowIconNewPass] = useState(false);
  const [showIconConfirmNewPass, setShowIconConfirmNewPass] = useState(false);

  function containsSpecialChars(str: string) {
    const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    return specialChars.test(str);
  }

  const handleCurrentPass = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = e.currentTarget;

      if (value.length < 8) {
        setCurrentPassError('A senha tem que ter no mínimo 8 caracteres');
      } else {
        setCurrentPassError('');
      }

      setCurrentPass(value);
    },
    []
  );

  const handleNewPassInput = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = e.currentTarget;
      const specialChars = containsSpecialChars(value);

      if (value.length < 8) {
        setNewPassError('A senha tem que ter no mínimo 8 caracteres');
      } else if (!specialChars) {
        setNewPassError('Insira pelo menos 1 caractere especial');
      } else {
        setNewPassError('');
      }

      setNewPass(value);
    },
    []
  );

  const handleConfirmPassInput = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = e.currentTarget;

      setConfirmNewPass(value);
    },
    []
  );

  // Compara Nova senha e Confirme senha
  useEffect(() => {
    if (confirmNewPass.length > 0 && confirmNewPass.length <= 3) {
      setConfirmNewPassError('A senha tem que ter mais de 3 caracteres');
    } else if (
      confirmNewPass.length > 0 &&
      newPass.localeCompare(confirmNewPass) !== 0
    ) {
      setConfirmNewPassError('As senhas digitadas não coincidem');
    } else {
      setConfirmNewPassError('');
    }
  }, [newPass, confirmNewPass]);

  const handleSubmitPass = useCallback(
    async (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();

      try {
        setLoading(true);

        const body = {
          email: userEmail,
          password: currentPass,
          newPassword: newPass,
        };

        await api.post('/users/change-password', body);
        setFormView(false);
        setHandleChangePass(false);
      } catch (error: any) {
        const errorMessage =
          String(error?.response?.data?.message) ??
          'Error ao realizar atualização da senha, tente novamente';
        // 'Error ao realizar atualização da informações do usuário, tente novamente';

        setModal(true);
        setModalMessage(errorMessage);
        setModalType('error');
        console.error(error);
      } finally {
        setLoading(false);
      }
    },
    [currentPass, newPass]
  );

  useEffect(() => {
    if (
      newPass !== '' &&
      currentPass !== '' &&
      confirmNewPass !== '' &&
      newPass === confirmNewPass &&
      newPass.length >= 8 &&
      confirmNewPass.length >= 8
    ) {
      setFormReady(true);
    } else {
      setFormReady(false);
    }
  }, [newPass, currentPass, confirmNewPass]);

  return (
    <>
      {modal && (
        <StatusModal setModal={setModal} text={modalMessage} type={modalType} />
      )}
      <Form onSubmit={handleSubmitPass}>
        <Container>
          <StyledInputWithIcon
            type={showIconCurrentPass ? 'text' : 'password'}
            placeholder="Senha atual"
            value={currentPass}
            sizeDisplay="sm"
            onChange={handleCurrentPass}
            error={!!currentPassError}
            errorMessage={currentPassError}
            showIcon={showIconCurrentPass}
            setShowIcon={setShowIconCurrentPass}
          />

          <StyledInputWithIcon
            type={showIconNewPass ? 'text' : 'password'}
            placeholder="Definir uma nova senha"
            value={newPass}
            sizeDisplay="sm"
            onChange={handleNewPassInput}
            error={!!newPassError}
            errorMessage={newPassError}
            showIcon={showIconNewPass}
            setShowIcon={setShowIconNewPass}
          />

          <StyledInputWithIcon
            type={showIconConfirmNewPass ? 'text' : 'password'}
            placeholder="Confirmar senha"
            value={confirmNewPass}
            sizeDisplay="sm"
            onChange={handleConfirmPassInput}
            error={!!confirmNewPassError}
            errorMessage={confirmNewPassError}
            disabled={!newPass}
            showIcon={showIconConfirmNewPass}
            setShowIcon={setShowIconConfirmNewPass}
          />
        </Container>

        <ButtonsContainer>
          <Button
            type="button"
            onClick={() => {
              setFormView(false);
              setHandleChangePass(false);
            }}
          >
            <FiChevronLeft />
            Cancelar
          </Button>
          <StyledButton
            text="Salvar"
            icon={<FiChevronRight />}
            iconPosition="right"
            type="submit"
            iconWhiteBackground
            iconBorderRadius
            disabled={!formReady}
          />
        </ButtonsContainer>
      </Form>
    </>
  );
};

export { PasswordForm };
